import { z } from 'zod';

export const IncomeDepartmentSchema = z.object({
  _id: z.string().optional(),
  name: z.string().min(1, 'Name is required').max(100),
  code: z.string().max(20).optional(),
  isActive: z.boolean().default(true),
  sortOrder: z.number().int().default(0),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

export type IncomeDepartment = z.infer<typeof IncomeDepartmentSchema>;

export const CreateIncomeDepartmentSchema = IncomeDepartmentSchema.omit({
  _id: true,
  createdAt: true,
  updatedAt: true,
});

export type CreateIncomeDepartment = z.infer<typeof CreateIncomeDepartmentSchema>;

export const UpdateIncomeDepartmentSchema = CreateIncomeDepartmentSchema.partial();

export type UpdateIncomeDepartment = z.infer<typeof UpdateIncomeDepartmentSchema>;
